/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const download_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.75 12.25 12 16.5m0 0 4.25-4.25M12 16.5V3M4 21.25h16"
    />
  </svg>
)
export default download_medium
